import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { MemberWithholdingStatus } from "@wingspanhq/users/dist/lib/interfaces";
import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../query/hooks/helpers";
import { useMutationUpdateMemberProfile } from "../../../query/users/mutations";
import { Layout } from "../../../shared/components/Layout";
import {
  CardOptOutSurvey,
  CardOptOutSurveyRef
} from "../components/CardOptOutSurvey";
import { PATH_TAXES } from "../paths";

export const RouteSurvey = () => {
  const history = useHistory();

  const surveyRef = useRef<CardOptOutSurveyRef>(null);

  const userId = useUserId();
  const [updateMemberProfile, updateMemberProfileMeta] =
    useMutationUpdateMemberProfile();

  return (
    <Layout title="Tax Withholdings">
      <WSList gap="2XL">
        <WSCard>
          <WSEmptyState
            orientation="horizontal"
            type="tasks"
            title="You’ve turned tax withholdings off"
            description={
              <WSInfoBox transparent>
                <p>
                  You’ve opted out of tax withholdings for now. Here’s what to
                  remember:
                </p>
                <ul>
                  <li>Quarterly deadlines: Apr 15, Jun 15, Sep 15, Jan 15</li>
                  <li>Set aside 25-30% of income for taxes</li>
                  <li>Use IRS Form 1040-ES for payments</li>
                  <li>Keep detailed income records</li>
                </ul>
                <p>
                  You can enable tax withholding anytime under your “Financial
                  benefits” section.
                </p>
              </WSInfoBox>
            }
          />
        </WSCard>

        <CardOptOutSurvey ref={surveyRef} />

        <WSActions
          orientation="vertical"
          buttons={[
            {
              label: "Continue",
              onClick: () => {
                surveyRef.current?.submit();
                history.push(PATH_TAXES);
              }
            },
            {
              kind: "Link",
              label: "I changed my mind, turn it back on",
              loading: updateMemberProfileMeta.isLoading,
              onClick: () => {
                updateMemberProfile(
                  {
                    memberId: userId,
                    profile: {
                      withholdings: {
                        tax: {
                          status: MemberWithholdingStatus.Active
                        }
                      }
                    }
                  },
                  {
                    onSuccess: () => {
                      history.push(PATH_TAXES);
                    }
                  }
                );
              }
            }
          ]}
        />
      </WSList>
    </Layout>
  );
};
